import { render, staticRenderFns } from "./edit.participants.page.vue?vue&type=template&id=6407b85d&"
import script from "./edit.participants.page.vue?vue&type=script&lang=js&"
export * from "./edit.participants.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports